export default __webpack_public_path__ + "static/media/e-Mandi Final Logo.afa54fc9.svg";